/* eslint-disable global-require */
module.exports = [...require('./Informations/i18n'), 'marketplace.stores.header.store.m1', 'components.account.confirm.m6', 'components.account.confirm.m5'];
